import creativeBuilderCardTpl from '../templates/ad_builder/creative_builder_card.html';

export default function creativeBuilderCard() {
  return {
    restrict: 'EA',
    template: creativeBuilderCardTpl,
    controller: 'CreativeBuilderCardController',
    controllerAs: 'cardVm',
    bindToController: true,
    scope: {
      creative: '=',
      partner: '=',
      active: '='
    }
  };
}
